export const Monogram = ({ size = 40, className = "", ...props }) => (
  <img
    src="/crest.png"
    alt="Smith family crest"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    {...props}
  />
);
